"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
const react_1 = __importStar(require("react"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
const DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
const Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
const DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const ButtonGroup_1 = __importDefault(require("@material-ui/core/ButtonGroup"));
const dialog_styles_1 = require("./dialog-styles");
const draggable_paper_1 = require("../draggable-paper/draggable-paper");
exports.Dialog = react_1.forwardRef(function Dialog({ title, children, onConfirm = lodash_1.stubTrue, onCancel = lodash_1.noop, onShow = lodash_1.noop, onShown = lodash_1.noop, showConfirm = true, confirmLabel, showClose = true, closeLabel, actions, loading = false, disableBackdrop = false, }, ref) {
    const classes = dialog_styles_1.useStyles();
    const [opened, setOpened] = react_1.useState(false);
    const open = event_callback_hook_1.useEventCallback(() => {
        onShow();
        requestAnimationFrame(() => {
            onShown();
        });
        setOpened(true);
    });
    const close = event_callback_hook_1.useEventCallback(() => setOpened(false));
    const handleConfirm = event_callback_hook_1.useEventCallback(async () => {
        let result = onConfirm();
        if (result instanceof Promise) {
            result = await result;
        }
        if (result !== false) {
            close();
        }
    });
    const handleCancel = event_callback_hook_1.useEventCallback(() => {
        onCancel();
        close();
    });
    react_1.useImperativeHandle(ref, () => ({
        open,
        close,
    }), [close, open]);
    const handleDialogClick = event_callback_hook_1.useEventCallback((event) => event.stopPropagation());
    return (react_1.default.createElement(Dialog_1.default, { onClick: handleDialogClick, open: opened, onClose: close, PaperComponent: draggable_paper_1.DragablePaper, maxWidth: "lg", disableBackdropClick: disableBackdrop },
        react_1.default.createElement(DialogTitle_1.default, { disableTypography: true, classes: { root: classes.title } },
            react_1.default.createElement(Typography_1.default, { className: classes.titleHeader, variant: "h6" }, title)),
        react_1.default.createElement(DialogContent_1.default, { dividers: true }, opened && children()),
        (showConfirm || actions || showClose) && (react_1.default.createElement(DialogActions_1.default, { classes: { root: classes.actions } },
            react_1.default.createElement(ButtonGroup_1.default, { size: "small", variant: "outlined" },
                showConfirm && (react_1.default.createElement(Button_1.default, { type: "submit", onClick: handleConfirm, variant: "outlined", color: "primary", disabled: loading, startIcon: loading && react_1.default.createElement(CircularProgress_1.default, { size: "20px", color: "inherit" }) },
                    react_1.default.createElement(Typography_1.default, { classes: { root: classes.buttonLabel } }, confirmLabel !== null && confirmLabel !== void 0 ? confirmLabel : (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_DIALOG_BTN_CONFIRM", defaultMessage: "Potvrdit" }))))),
                actions,
                showClose && (react_1.default.createElement(Button_1.default, { variant: "outlined", onClick: handleCancel, disabled: loading },
                    react_1.default.createElement(Typography_1.default, { classes: { root: classes.buttonLabel } }, closeLabel !== null && closeLabel !== void 0 ? closeLabel : (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_DIALOG_BTN_CANCEL", defaultMessage: "Zru\u0161it" }))))))))));
});
//# sourceMappingURL=dialog.js.map